

























import { Component, Vue, Prop } from 'vue-property-decorator'
import Timeline from '@/components/Timeline.vue'
import { controlLoop } from '@/components/helpers/utils'
import TimelineControls from '@/components/TimelineControls.vue'

@Component({ components: { Timeline, TimelineControls } })
export default class PronosticoMeteorologicoFooter extends Vue {
  @Prop() timelineList!: string[]
  @Prop() currentPosition!: number
  private precipitacionImage: string = 'https://explora.alertahidrica.cl/pronostico/Precipitacion_colorbarHorizontal_w.png'
  private vientoImage: string = 'https://explora.alertahidrica.cl/pronostico/MagnitudViento_colorbarHorizontal_w.png'
  private temperaturaImage: string = 'https://explora.alertahidrica.cl/pronostico/Temperatura_colorbarHorizontal_w.png'
  private control!: any

  created () {
    this.control = controlLoop(() => {
      this.$emit('timeSelected', { position: this.nextPosition })
    })
  }

  destroyed () {
    this.control.destroy()
  }

  timeSelected (event: MouseEvent) {
    this.control.pause()
    this.$emit('timeSelected', event)
  }

  get nextPosition () {
    const len = this.timelineList.length
    if (this.currentPosition < (len - 1)) {
      return this.currentPosition + 1
    }
    return 0
  }

  get previousPosition () {
    if (this.currentPosition > 0) {
      return this.currentPosition - 1
    }
    return this.timelineList.length - 1
  }

  get computedImage () {
    const type = this.$route.query.type.toString()
    switch (type) {
      case 'Precipitacion':
        return this.precipitacionImage
      case 'MagnitudViento':
        return this.vientoImage
      case 'Temperatura':
        return this.temperaturaImage
    }
  }

  next () {
    this.control.pause()
    this.$emit('timeSelected', { position: this.nextPosition })
  }

  previous () {
    this.control.pause()
    this.$emit('timeSelected', { position: this.previousPosition })
  }

  paused () {
    this.control.pause()
  }

  played () {
    this.control.play()
  }
}
